/**
 * Bedrock cross-region inference geo — the prefix on a cross-region inference
 * profile id (`eu.anthropic.claude-opus-4-8`), and the dimension LLM prices are
 * keyed on.
 *
 * Deliberately not an AWS region: Bedrock bills a cross-region profile at one
 * flat rate across every AWS region it spans, so `eu-west-2` and `eu-central-1`
 * share both the `eu.` profile and its price. The geo is the finest granularity
 * at which prices actually differ.
 *
 * Distinct from `WexlerRegion` in ./model-registry.ts, which tags the same three
 * deployments but spells the APAC one `apac` rather than Bedrock's `au`. These
 * values must match `serving_geo()` in chronos-ml's kim-agent, which is what
 * builds the price lookup key.
 */
export enum ServingGeo {
  Eu = 'eu',
  Us = 'us',
  Au = 'au',
}
